"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarqueeSlider = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var styled_components_1 = __importDefault(require("styled-components"));
var styles_1 = require("../../styles");
var MarqueeSliderWrapper = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n  background-color: ", ";\n  position: relative;\n  display: flex;\n\n  padding: ", " 0;\n\n  ", "\n\n  p {\n    ", "\n    color: ", ";\n    white-space: nowrap;\n    animation: marquee linear infinite;\n    animation-duration: ", "s;\n  }\n\n  @keyframes marquee {\n    0% {\n      transform: translateX(0%);\n    }\n\n    100% {\n      transform: translateX(-100%);\n    }\n  }\n\n  .marquee-cart-item,\n  .marquee-personal-data-item,\n  .marquee-orders-item {\n    font-family: ", ";\n    letter-spacing: 3px;\n    line-height: ", ";\n    padding-bottom: 0;\n  }\n\n  .marquee-cart-item {\n    padding-bottom: ", ";\n  }\n\n  ", "\n"], ["\n  ", "\n  background-color: ", ";\n  position: relative;\n  display: flex;\n\n  padding: ", " 0;\n\n  ", "\n\n  p {\n    ", "\n    color: ", ";\n    white-space: nowrap;\n    animation: marquee linear infinite;\n    animation-duration: ", "s;\n  }\n\n  @keyframes marquee {\n    0% {\n      transform: translateX(0%);\n    }\n\n    100% {\n      transform: translateX(-100%);\n    }\n  }\n\n  .marquee-cart-item,\n  .marquee-personal-data-item,\n  .marquee-orders-item {\n    font-family: ", ";\n    letter-spacing: 3px;\n    line-height: ", ";\n    padding-bottom: 0;\n  }\n\n  .marquee-cart-item {\n    padding-bottom: ", ";\n  }\n\n  ", "\n"])), (0, styles_1.hideScrollbar)(), function (_a) {
    var theme = _a.theme, inverted = _a.inverted;
    return inverted ? theme.colors.creamlight : theme.colors.background;
}, (0, styles_1.getRelative)(20, 'mobile'), styles_1.mq.greaterThan('tablet')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: ", " 0;\n  "], ["\n    padding: ", " 0;\n  "])), (0, styles_1.getRelative)(40, 'desktop')), (0, styles_1.getP93)(), function (_a) {
    var theme = _a.theme, inverted = _a.inverted;
    return inverted ? theme.colors.background : theme.colors.creamlight;
}, function (_a) {
    var textWidth = _a.textWidth;
    return textWidth / 3;
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.platform;
}, (0, styles_1.getRelative)(93, 'mobile'), (0, styles_1.getRelative)(60, 'mobile'), styles_1.mq.greaterThan('tablet')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin-top: ", ";\n\n    .marquee-cart-item,\n    .marquee-personal-data-item,\n    .marquee-orders-item {\n      line-height: ", ";\n    }\n\n    .marquee-cart-item {\n      padding-bottom: ", ";\n    }\n  "], ["\n    margin-top: ", ";\n\n    .marquee-cart-item,\n    .marquee-personal-data-item,\n    .marquee-orders-item {\n      line-height: ", ";\n    }\n\n    .marquee-cart-item {\n      padding-bottom: ", ";\n    }\n  "])), function (_a) {
    var uniqueClass = _a.uniqueClass;
    return uniqueClass === 'marquee-personal-data-item' || uniqueClass === 'marquee-orders-item' || uniqueClass === 'marquee-directions-item' ? "".concat((0, styles_1.getRelative)(30, 'desktop')) : '0';
}, (0, styles_1.getRelative)(93, 'desktop'), (0, styles_1.getRelative)(60, 'desktop')));
var TRANSLATIONS = {
    'es': {
        'cart': [
            'Tu cesta',
            'artículos',
            'artículo'
        ],
        'personal-data': 'Datos personales',
        'orders': 'Mis pedidos',
        'directions': 'Direcciones'
    },
    'en': {
        'cart': [
            'Your cart',
            'items',
            'item'
        ],
        'personal-data': 'Personal information',
        'orders': 'My orders',
        'directions': 'Addresses'
    },
    'it': {
        'cart': [
            'Il tuo carrello',
            'articoli',
            'articolo'
        ],
        'personal-data': 'Informazione personale',
        'orders': 'I miei ordini',
        'directions': 'Indirizzi'
    },
    'fr': {
        'cart': [
            'Votre panier',
            'articles',
            'article'
        ],
        'personal-data': 'Informations personnelles',
        'orders': 'Mes commandes',
        'directions': 'Adresses'
    }
};
var modifyData = function (NEXT_LOCALE, data) {
    var _a;
    if (data === 'cart') {
        var marqueeWrapperCart = document.querySelector('#marquee-cart');
        // @ts-ignore
        var cartItemQuantity = (_a = marqueeWrapperCart === null || marqueeWrapperCart === void 0 ? void 0 : marqueeWrapperCart.dataset) === null || _a === void 0 ? void 0 : _a.quantity;
        if (cartItemQuantity === '1') {
            return "".concat(TRANSLATIONS[NEXT_LOCALE].cart[0], " (").concat(cartItemQuantity, " ").concat(TRANSLATIONS[NEXT_LOCALE].cart[2], ")");
        }
        else {
            return "".concat(TRANSLATIONS[NEXT_LOCALE].cart[0], " (").concat(cartItemQuantity, " ").concat(TRANSLATIONS[NEXT_LOCALE].cart[1], ")");
        }
    }
    else if (data) {
        return TRANSLATIONS[NEXT_LOCALE][data];
    }
};
var getCookies = function (name) {
    var e_1, _a;
    var nameEQ = "".concat(name, "=");
    if (typeof window === 'undefined')
        return null;
    var arrayOfCookies = document.cookie.split(';');
    try {
        for (var arrayOfCookies_1 = __values(arrayOfCookies), arrayOfCookies_1_1 = arrayOfCookies_1.next(); !arrayOfCookies_1_1.done; arrayOfCookies_1_1 = arrayOfCookies_1.next()) {
            var rawCookie = arrayOfCookies_1_1.value;
            var cookie = rawCookie;
            while (cookie.charAt(0) == ' ')
                cookie = cookie.substring(1, cookie.length);
            if (cookie.indexOf(nameEQ) == 0)
                return cookie.substring(nameEQ.length, cookie.length);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (arrayOfCookies_1_1 && !arrayOfCookies_1_1.done && (_a = arrayOfCookies_1.return)) _a.call(arrayOfCookies_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return null;
};
exports.MarqueeSlider = (0, react_1.memo)(function (_a) {
    var data = _a.data, _b = _a.uniqueClass, uniqueClass = _b === void 0 ? 'marquee-item' : _b, _c = _a.inverted, inverted = _c === void 0 ? false : _c;
    var NEXT_LOCALE = getCookies('NEXT_LOCALE') || 'es';
    var _data = (0, react_1.useMemo)(function () {
        if (data === 'cart' || data === 'personal-data' || data === 'orders' || data === 'directions') {
            return modifyData(NEXT_LOCALE, data);
        }
        return data;
    }, [data]);
    return ((0, jsx_runtime_1.jsxs)(MarqueeSliderWrapper, __assign({ textWidth: _data.length * 5, className: 'marquee', inverted: inverted, uniqueClass: uniqueClass }, { children: [(0, jsx_runtime_1.jsxs)("p", __assign({ className: uniqueClass }, { children: ["\u00A0\u00A0", _data, "\u00A0\u00A0\u2022\u00A0\u00A0", _data, "\u00A0\u00A0\u2022\u00A0\u00A0", _data, "\u00A0\u00A0\u2022\u00A0\u00A0", _data, "\u00A0\u00A0\u2022\u00A0\u00A0", _data, "\u00A0\u00A0\u2022"] })), (0, jsx_runtime_1.jsxs)("p", __assign({ className: uniqueClass }, { children: ["\u00A0\u00A0", _data, "\u00A0\u00A0\u2022\u00A0\u00A0", _data, "\u00A0\u00A0\u2022\u00A0\u00A0", _data, "\u00A0\u00A0\u2022\u00A0\u00A0", _data, "\u00A0\u00A0\u2022\u00A0\u00A0", _data, "\u00A0\u00A0\u2022"] }))] })));
});
var templateObject_1, templateObject_2, templateObject_3;
